import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { analyticsApiKeY } from 'apollo/cache';
import { useReactiveVar } from '@apollo/client';

const useAnalytics = (): boolean => {
  const [initialized, setInitialized] = useState(false);
  const apiKey = useReactiveVar(analyticsApiKeY);

  useEffect(() => {
    if (
      !window.location.href.includes('localhost') &&
      !window.location.href.includes('.dev') &&
      apiKey
    ) {
      ReactGA.initialize(apiKey);
      setInitialized(true);
    }
  }, [apiKey]);

  return initialized;
};

export default useAnalytics;
